// removed by extract-text-webpack-plugin
module.exports = {"container":"RecentlyViewedItems__container__fa63428a"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/RecentlyViewedItems/RecentlyViewedItems.scss
// module id = 3487
// module chunks = 7